/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C3a §3] THE WORDS FOR ATTACHED FILES — MOVED, BECAUSE TWO SCREENS NOW SAY THEM.
 *
 *  §3 puts the same control on the arrangement BUILDER's first step, so the vocabulary left
 *  `pages/ArrangementDetail/copy.ts` for the reason `components/fill/copy.ts` and
 *  `components/intake/copy.ts` exist. Every string below is unchanged.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
/**
 * ⚠️ [C2b §3] THE WORDS FOR ATTACHED FILES.
 *
 * The empty state SAYS WHAT THE FEATURE IS FOR rather than "No attachments" — a labelled empty
 * box teaches nobody that a route map can be pinned here, and `EmptyState`'s own rule is that
 * an empty list explains itself.
 */
export const ATTACHMENT_COPY = {
  /** ⚠️ [C3a §3] A file chosen before the draft exists — held, not uploaded. */
  pending: 'Not saved yet — it uploads when the draft is saved.',
  title: 'Files',
  add: 'Attach a PDF',
  remove: 'Remove',
  removeLabel: (filename: string): string => `Remove ${filename}`,
  emptyTitle: 'No files yet',
  emptyBody: 'Attach a route map, a sketch or a signed copy of the order. PDF only, up to 5 MB.',
  added: (filename: string): string => `${filename} attached`,
  tooLarge: 'That file is larger than 5 MB. Attach a smaller PDF.',
  /** ⚠️ Size in whole KB or MB — a byte count on screen is a number nobody reads. */
  meta: (sizeBytes: number, uploader: string | null): string => {
    const size =
      sizeBytes >= 1024 * 1024
        ? `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`
        : `${String(Math.max(1, Math.round(sizeBytes / 1024)))} KB`;
    return uploader === null ? size : `${size} · ${uploader}`;
  },
} as const;

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C3b §5] THE ONE PDF READER'S WORDS. Shared by every surface that opens an attachment.
 *
 *  ⚠️ THE NOTE IS NOT DECORATION. A browser with its built-in PDF viewer disabled renders an
 *  empty frame and fires no error event, so nothing in the code can detect it and offer help.
 *  The sentence and the always-present Download button are the whole of the fallback.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
/**
 * ⚠️ [C3b §4] THE COUNT IS IN THE LABEL, because a menu that might be empty is a menu nobody
 * opens twice. `AttachmentsMenu` renders nothing at zero, so this never reads "View files (0)".
 */
export const VIEW_FILES_LABEL = (count: number): string => `View files (${String(count)})`;

export const PDF_VIEWER_COPY = {
  title: 'Attachment',
  download: 'Download',
  loading: 'Opening…',
  note: 'If nothing appears below, your browser cannot display PDFs — use Download.',
} as const;
